<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.conclusions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-row>
                        <b-col sm="1">
                        </b-col>
                        <b-col sm="10">

                            <b-form-group
                                    id="consultation-group"
                                    :label="$tc('message.generalConsultations', 1)"
                                    label-for="consultation"
                            >
                                <b-form-input
                                        id="consultation"
                                        v-model="mConsultation"
                                        disabled
                                >
                                </b-form-input>

                                <!--                                    <b-form-invalid-feedback v-if="!$v.form.consultation.required">-->
                                <!--                                        {{ $t('message.requiredField') }}-->
                                <!--                                    </b-form-invalid-feedback>-->

                                <b-form-invalid-feedback v-if="errorshasField('consultation_medecine_generale_id')">
                                    {{ getErrorsField('consultation_medecine_generale_id') }}
                                </b-form-invalid-feedback>
                            </b-form-group>

<!--                            <b-form-group-->
<!--                                    id="consultation-group"-->
<!--                                    :label="$tc('message.generalConsultations', 1)"-->
<!--                                    label-for="consultation">-->
<!--                                <b-form-select-->
<!--                                        id="consultation"-->
<!--                                        v-model="$v.form.consultation_medecine_generale_id.$model"-->
<!--                                        :state="$v.form.consultation_medecine_generale_id.$dirty ? !(errorshasField('consultation_medecine_generale_id') || $v.form.consultation_medecine_generale_id.$error) : null"-->
<!--                                        :options="mConsultations"-->
<!--                                        required-->
<!--                                        @focus="clearErrorField('consultation_medecine_generale_id')"-->
<!--                                ></b-form-select>-->

<!--                                <b-form-invalid-feedback v-if="!$v.form.consultation_medecine_generale_id.required">-->
<!--                                    {{ $t('message.requiredField') }}-->
<!--                                </b-form-invalid-feedback>-->

<!--                                <b-form-invalid-feedback v-else-if="errorshasField('consultation_medecine_generale_id')">-->
<!--                                    {{ getErrorsField('consultation_medecine_generale_id') }}-->
<!--                                </b-form-invalid-feedback>-->
<!--                            </b-form-group>-->
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="1">
                        </b-col>
                        <b-col sm="10">
                            <b-form-group
                                    id="reference-group"
                                    :label="$t('message.reference')"
                                    label-for="reference"
                            >
                                <b-form-input
                                        id="type"
                                        v-model="$v.form.reference.$model"
                                        :state="$v.form.reference.$dirty ? !(errorshasField('reference') || $v.form.reference.$error) : null"
                                        required
                                        @focus="clearErrorField('reference')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="!$v.form.reference.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('reference')">
                                    {{ getErrorsField('reference') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="1">
                        </b-col>
                        <b-col sm="10">
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description"
                            >
                                <b-form-textarea
                                        id="description"
                                        v-model="$v.form.description.$model"
                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                        required
                                        @focus="clearErrorField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasAdminRole">
                        <b-button type="submit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>

<!--                        <b-button type="reset" variant="danger">-->
<!--                            {{ $t('message.reset') }}-->
<!--                        </b-button>-->
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';

    export default {
        name: "EditConclusion",

        computed: {
            ...mapGetters(["conclusion", "generalConsultation", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            form: function() {
                return this.conclusion;
            },

            mConsultation: function() {
                let conclusion = this.conclusion;
                if(typeof conclusion.user == 'object'){
                    let user = conclusion.user;

                    let nom = user.nom + ((user.prenom != null && user.prenom) ? (' ' + user.prenom) : '');
                    let dossier = conclusion.dossier.numero_dossier;

                    let text = nom + ' ( ' + dossier + ' )' + " " +conclusion.consultation_medecine.date_consultation;
                    return text;
                }
                return  "";
            },

            can: function () {
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            }
        },

        data() {
            return {
                conclusion_id: this.$route.params.conclusion,
                show: true
            }
        },

        methods: {
            getConclusion: function() {
                let args = {
                    conclusion: this.conclusion_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getConclusion', { args, errorMessages });
            },

            getConsultations: function() {
                let args = {};

                this.$store.dispatch('getGeneralConsultations', { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        conclusion: this.conclusion_id,
                        consultation_medecine_generale_id: this.form.consultation_medecine.id,
                        reference: this.form.reference,
                        description: this.form.description
                    };

                    let successMessage = this.$i18n.t('message.conclusionUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateConclusion', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.consultation_medecine_generale_id = '';
                this.form.reference = '';
                this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors.hasOwnProperty(field);
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                // consultation_medecine_generale_id: {
                //     required
                // },
                reference: {
                    required
                },
                description: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve conclusion
            this.getConclusion();

            // // Retrieve general consultation list
            // this.getConsultations();
        }
    }
</script>

<style scoped>

</style>